import Patient from "./Patient"

import PatientAccount from "./account/Account"
import PatientOverview from "./Overview"
import PatientResponse from "./response/Response"
import PatientMessage from "./message/Message"
import PatientFacesheet from "./facesheet/Facesheet"
import PatientChart from "./chart/Chart"
import PatientRecord from "./record/Record"
import PatientProgress from "./progress/Progress"
import PatientAssessment from "./assessment/Assessment"

export default [
  {
    path: "provider/:providerId/:id",
    component: Patient,
    props: true,

    children: [
      {
        path: "",
        component: PatientOverview,
        props: true,

        icon: "overview",
        text: "Overview",
      },
      {
        path: "response",
        component: PatientResponse,
        props: true,

        icon: "responses",
        text: "Responses",
      },
      {
        path: "message",
        component: PatientMessage,
        props: true,

        icon: "messages",
        text: "Messages",
      },
      {
        path: "report",
        component: PatientFacesheet,
        props: true,

        icon: "facesheet",
        text: "Face Sheet",
      },
      {
        path: "chart",
        component: PatientChart,
        props: true,

        icon: "chart",
        text: "Copy To Chart",
      },
      {
        path: "record",
        component: PatientRecord,
        props: true,

        icon: "record",
        text: "Records",
      },
      {
        path: "progress",
        component: PatientProgress,
        props: true,
        icon: "progress",
        text: "Progress",
      },
      {
        path: "assessment",
        component: PatientAssessment,
        props: true,
        icon: "assessment",
        text: "Assessment / Plan",
      },
      {
        path: "account",
        component: PatientAccount,
        props: true,
        hidden: true,
      },
    ],
  },
  {
    path: ":id",
    component: Patient,
    props: true,

    children: [
      {
        path: "",
        component: PatientOverview,
        props: true,

        icon: "overview",
        text: "Overview",
      },
      {
        path: "response",
        component: PatientResponse,
        props: true,

        icon: "responses",
        text: "Responses",
      },
      {
        path: "message",
        component: PatientMessage,
        props: true,

        icon: "messages",
        text: "Messages",
      },
      {
        path: "report",
        component: PatientFacesheet,
        props: true,

        icon: "facesheet",
        text: "Face Sheet",
      },
      {
        path: "chart",
        component: PatientChart,
        props: true,
        icon: "chart",
        text: "Copy To Chart",
      },
      {
        path: "record",
        component: PatientRecord,
        props: true,
        icon: "record",
        text: "Records",
      },
      {
        path: "progress",
        component: PatientProgress,
        props: true,
        hidden: true,
        icon: "progress",
        text: "Progress",
      },
      {
        path: "account",
        component: PatientAccount,
        props: true,
        hidden: true,
      },
    ],
  }
];
